(function () {
  'use strict';

  angular
    .module('app')
    .component('providerCreditNoteRelatedTransactions', providerCreditNoteRelatedTransactions());

  function providerCreditNoteRelatedTransactions() {
    return {
      bindings: {
        creditNote: '<',
        providerId: '<',
      },
      controller: ProviderCreditNoteRelatedTransactions,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/provider-credit-notes/components/provider-credit-note-related-transactions/' +
        'provider-credit-note-related-transactions.component.html',
    };
  }

  ProviderCreditNoteRelatedTransactions.$inject = [
    'ProviderCreditNoteService',
    'RelatedTransactionService',
  ];

  function ProviderCreditNoteRelatedTransactions(
    ProviderCreditNoteService,
    RelatedTransactionService
  ) {
    let vm = this;

    // Methods
    vm.selectTransaction = selectTransaction;
    vm.openRelatedTransactionModal = openRelatedTransactionModal;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;
      ProviderCreditNoteService.getRelatedTransactions(vm.creditNote.id, vm.providerId).then(
        function (data) {
          vm.bookings = data.bookings;
          vm.bill = data.bill.bill;
          vm.providerCreditNotes = data.bill.data.providerCreditNotes;

          vm.providerCreditNotes.forEach((providerCreditNote) => {
            providerCreditNote.bill = angular.copy(vm.bill);
            providerCreditNote.bookings = data.bookings.length > 0 ? angular.copy(vm.bookings) : [];
          });

          if (data.bill.data.providerCreditNotes.length > 0) {
            vm.providerCreditNotes = data.bill.data.providerCreditNotes;
          }

          if (data.bill.data.paymentProviders.length > 0) {
            vm.paymentProviders = data.bill.data.paymentProviders;
          }

          vm.loadingRelatedTransactions = false;
        }
      );
    }

    function selectTransaction(transaction, index) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;

      if (index !== undefined) {
        vm.indexSelected = index;
      }
    }

    function openRelatedTransactionModal(transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    }
  }
})();
